import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, finalize } from 'rxjs';
import { NotificationService } from '../services/notification.service';

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  private notificationService = inject(NotificationService);
  private readonly excludedRoutes: string[] = ['api/v1/businessSubject/filter'];
  private readonly enableLoaderForMethods = ['GET', 'POST', 'PUT', 'DELETE'];

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    if (
      !this.enableLoaderForMethods.includes(request.method) ||
      this.excludedRoutes.some((route) => request.url.includes(route))
    ) {
      return next.handle(request);
    }
    this.notificationService.setLoading(true);
    return next
      .handle(request)
      .pipe(finalize(() => this.notificationService.setLoading(false)));
  }
}
